import 'babel-polyfill'
import 'classlist-polyfill'
import Vue from 'vue'
import axios from './router/axios'
import VueAxios from 'vue-axios'
import App from './App'
import './permission' // 权限
import './error' // 日志
import router from './router/router'
import store from './store'
import util from '@/util/util'
import * as urls from '@/config/env'
import { iconfontUrl, iconfontVersion } from '@/config/env'
import * as filters from './filters' // 全局filter
import './styles/common.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'
import basicContainer from './components/basic-container/main'
// 富文本编辑器外部引用样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/styles/quill.custom.scss' // 字体文件
//iconfont ali
import './assets/iconfont/iconfont.css'
import VueCookies from 'vue-cookies'
//组件
import CrudSelect from '@/components/form/crud-select';
import CrudRadio from '@/components/form/crud-radio';
import filePreview from "@/components/common/filePreview";



// 全局的变量
import global from '@/const/global'

import validate from '@/util/validate'

import ace from 'ace-builds'

// 装修页面引入
import lodash from './util/lodash'
window.lodash = lodash

import Toast from '@/components/toast'
Vue.prototype.$toast = Toast.install

Vue.prototype.checkNull = validate.checkNull
Vue.prototype.downloadFile = util.downloadFile
Vue.prototype.global = global
Vue.prototype.MEDIA_TYPE = global.MEDIA_TYPE

Vue.use(ElementUI, {
  size: 'medium',
  menuType: 'text',
})
Vue.use(Avue, {
  size: 'medium',
  menuType: 'text',
})

Vue.use(router)

Vue.use(VueAxios, axios)

Vue.use(ace)

Vue.use(VueCookies)

// 注册全局容器
Vue.component('basicContainer', basicContainer)
Vue.component('crudSelect', CrudSelect)
Vue.component('crudRadio', CrudRadio)
Vue.component('filePreview', filePreview)

// 加载相关url地址
Object.keys(urls).forEach((key) => {
  Vue.prototype[key] = urls[key]
})

//加载过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

// 动态加载阿里云字体库
iconfontVersion.forEach((ele) => {
  util.loadStyle(iconfontUrl.replace('$key', ele))
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

